import { useEffect, useState } from "react";
import { useParams, useOutletContext } from "react-router-dom";
import { Box, Paper, Typography } from "@mui/material";

import Loader from "../../components/Loader";
import useGetTrialForPatient from "../../hooks/useGetTrialForPatient";
import useGetVisitConfigLogs from "../../hooks/useGetVisitConfigLogs";
import VisitConfigLogTable from "./VisitConfigLogTable";

const VisitConfigLogs = () => {
  const { _id_ } = useParams();
  const { trialFilter, setActive, setBreadcrumbTitle } = useOutletContext();

  setActive("visitConfigLogs");
  setBreadcrumbTitle("Visit Config Logs");

  const [trialId, setTrialId] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const { data: trialData } = useGetTrialForPatient({
    patientId: _id_,
    trialId: trialFilter,
    enabled: !!trialFilter,
  });

  useEffect(() => {
    if (trialData?.trial?.id) {
      setTrialId(trialData.trial.id);
    }
  }, [trialData]);

  const { data: logs, isLoading } = useGetVisitConfigLogs({
    page: currentPage,
    trialId,
    patientId: _id_,
    enabled: trialId > 0,
  });

  return (
    <Paper elevation={1} sx={{ p: 2 }}>
      <Typography variant="h6" mb={2}>
        Visit Config Logs
      </Typography>

      {isLoading ? (
        <Box display="flex" justifyContent="center" py={6}>
          <Loader />
        </Box>
      ) : (
        <VisitConfigLogTable logs={logs} currentPage={currentPage} onPageChange={setCurrentPage} />
      )}
    </Paper>
  );
};

export default VisitConfigLogs;
